import React, { memo, useMemo } from 'react';
import {
	Route,
	Switch,
	useRouteMatch
} from 'react-router-dom';

import { log } from '../../../../services/utils';
import { Provider as ProgramsProvider } from '../../../../contexts/ProgramsContext';
import { Provider as SubmissionsProvider } from '../../../../contexts/SubmissionsContext';

import ProgramDetails from '../../Operations/Programs/ProgramDetails';
import TemplateDetails from '../../Operations/Programs/ProgramDetails/TemplateDetails';

const Onboarding = () => {
	let { path } = useRouteMatch();

	const override = useMemo( () => ( {
		breadcrumb: <span>Agencies &nbsp;&#9656;&nbsp; Onboarding</span>,
		id: 'onboarding',
		infobarLoader: 'Retrieving Onboarding Info...',
		isSystem: true,
		path: '/agencies/onboarding'
	} ), [] );

	return (
		<ProgramsProvider override={ override }>
			<SubmissionsProvider>
				{ log( 'onboarding' ) }
				<Switch>
					<Route
						exact
						path={ `${ path }/templates/:templateId` }
						component={ TemplateDetails }
					/>
					<Route
						exact
						path={ path }
						render={ () => <ProgramDetails /> }
					/>
				</Switch>
			</SubmissionsProvider>
		</ProgramsProvider>
	);
};

export default memo( Onboarding );
